export const formatZipCode = (zipCode: string) => {
  if (zipCode.length <= 5) {
    return zipCode;
  } else {
    return `${zipCode.slice(0, 5)}-${zipCode.slice(5)}`;
  }
};
